"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asynciterator_1 = require("asynciterator"); // based on https://github.com/LinkedDataFragments/Client.js/blob/master/lib/sparql/SortIterator.js


var SortIterator =
/*#__PURE__*/
function (_asynciterator_1$Tran) {
  _inherits(SortIterator, _asynciterator_1$Tran);

  function SortIterator(source, sort, options) {
    var _this;

    _classCallCheck(this, SortIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SortIterator).call(this, source, options)); // The `window` parameter indicates the length of the sliding window to apply sorting

    var window = options && options.window;
    _this.windowLength = isFinite(window) && window > 0 ? window : Infinity;
    _this.sort = sort;
    _this.sorted = [];
    return _this;
  } // Reads the smallest item in the current sorting window


  _createClass(SortIterator, [{
    key: "_read",
    value: function _read(count, done) {
      var item;
      var length = this.sorted.length; // Try to read items until we reach the desired window length

      while (length !== this.windowLength) {
        item = this.source.read();

        if (item === null) {
          break;
        } // Insert the item in the sorted window (smallest last)


        var left = 0;
        var right = length - 1;
        var mid = void 0;
        var order = void 0;

        while (left <= right) {
          mid = Math.trunc((left + right) / 2);
          order = this.sort(item, this.sorted[mid]);

          if (order < 0) {
            left = mid + 1;
          } else if (order > 0) {
            right = mid - 1;
          } else {
            left = mid;
            right = -1;
          }
        }

        this.sorted.splice(left, 0, item);
        length++;
      } // Push the smallest item in the window


      if (length === this.windowLength) {
        this._push(this.sorted.pop());
      }

      done();
    } // Flushes remaining data after the source has ended

  }, {
    key: "_flush",
    value: function _flush(done) {
      var length = this.sorted.length;

      while (length--) {
        this._push(this.sorted.pop());
      }

      done();
    }
  }]);

  return SortIterator;
}(asynciterator_1.TransformIterator);

exports.SortIterator = SortIterator;